const extractMediaData = require("./extractMediaData");
const extractVideoData = require("./extractVideoData");

module.exports = function transformBannerData(entity) {
	const { attributes } = entity;
	let data = {
		id: entity.id,
		type: entity.type,
		image: extractMediaData(entity),
		video: extractVideoData(entity),
		size: attributes ? attributes.field_banner_size : "sm",
		search: attributes && attributes.field_display_search_form === true,
		searchPlaceholder:
			attributes && attributes.field_search_placeholder
				? attributes.field_search_placeholder
				: "Search this website...",
	};
	if (!data.image) data.image = { src: "/default.jpg", alt: "default image" };
	return data;
};
